import { APICallV3Post } from 'reactApp/api/APICall';

export class FavoritesAddAPICall extends APICallV3Post {
    _method = 'favorites/add';
}
